export const getDay = (date, time) => {
  const dateOptions = {
    day: "numeric",
    year: "numeric",
    month: "long",
    timeZone: "America/Los_Angeles",
  };

  const timeOptions = {
    hour: "numeric",
    minute: "numeric",
    timeZone: "America/Los_Angeles",
    timeZoneName: "short",
  };

  const formattedDate = new Date(`${date.toString()}T${time.toString()}-0700`);

  return {
    date: formattedDate.toLocaleString("en-US", dateOptions),
    time: formattedDate.toLocaleString("en-US", timeOptions),
  };
};
